import React from 'react';
import PropTypes from 'prop-types';

import Image from 'marketing-website/components/modules/Image';
import MediaMultipleImages from 'marketing-website/components/modules/Media/MediaMultipleImages';
import ParallaxWrapper from 'marketing-website/components/wrappers/ParallaxWrapper';
import Pattern from 'marketing-website/components/commons/Pattern';
import Shape from 'marketing-website/components/commons/Shape';

import assets from 'marketing-website/configs/pages/why-marvel/assets.js';

export default function CollaborationArtwork({ color, patternColor }) {
  return (
    <MediaMultipleImages
      fallbackImageAlt="Open collaboration and centralised feedback"
      fallbackImageMaxWidth={599}
      fallbackImageSrc={assets.collaboration.src}
    >
      <Shape
        color={color}
        height={250}
        left="0"
        top="35%"
        type="rectangle"
        width={450}
      />
      <Pattern type="shortRectangle" top="45%" left="5%" color={patternColor} />
      <ParallaxWrapper speed={0.8}>
        <Image
          {...assets.tabBack}
          borderRadius="m"
          maxWidth={430}
          position="absolute"
          left="6%"
          top="15%"
        />
      </ParallaxWrapper>
      <ParallaxWrapper speed={1.6}>
        <Image
          {...assets.tabFront}
          borderRadius="m"
          left="26%"
          maxWidth={362}
          position="absolute"
          top="30%"
        />
      </ParallaxWrapper>
    </MediaMultipleImages>
  );
}

CollaborationArtwork.propTypes = {
  patternColor: PropTypes.string,
  color: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/modules/CollaborationArtwork/index.js